import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { formatOperationalHour, isEmptyData } from '../../../../utils/helper';
import { useMemo } from 'react';
import HourTime from '../HourTime';

const OperationalHour = () => {
	const { details: outlet } = useSelector((store) => store?.outlet);
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	const operational = useMemo(() => {
		if (isEmptyData(outlet?.operationalHour)) return [];
		return formatOperationalHour(outlet?.operationalHour);
	}, [outlet?.operationalHour]);

	const currentOperational = useMemo(() => {
		if (!operational?.length) return null;
		return operational.find((op) => op?.isActive);
	}, [operational]);

	return (
		<>
			<div className={`font-medium text-xxs ${currentOperational?.isActive ? 'text-green-600' : 'text-red-600'}`}>{currentOperational?.isActive ? 'Open' : 'Closed'}</div>

			<div className='font-medium text-xxs text-gray-700 flex items-center gap-1' onClick={() => setIsShowBottomSheet(true)}>
				{currentOperational?.jam} <ChevronDownIcon className='w-3 h-auto text-gray-800' strokeWidth={3} />
			</div>
			<BottomSheet key={'operational-hour'} open={isShowBottomSheet} onDismiss={handleCloseBottomSheet}>
				<div className='m-4'>
					<div className='text-center font-semibold text-base text-gray-700 mb-4'>Operational Hours</div>
					<div className='border-t-1 border-solid border-gray-200' />
					<HourTime {...{ operational }} />
				</div>
			</BottomSheet>
		</>
	);
};

export default OperationalHour;
